import IconPicker from '../../../scripts/iconpicker-1.5.0.js';

angular.module("events_types")

    .controller("EventsTypesEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal) {
        
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("EVENTS_TYPES_WRITE");
        $rootScope.title = $filter('translate')('events_types.title');

        $scope.event_type = {};

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
       
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events_types.title'), url: "events_types.list" },
                { title: $filter('translate')('events_types.title_add') },
            ];
             
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events_types.title'), url: "events_types.list" },
                { title: $filter('translate')('events_types.title_edit') },
            ];

            Restangular.one('EventsTypes', $stateParams.id).get().then(function (result) {
                
                $scope.event_type = result;                
            });
            }

            IconPicker.Init({
                // Required: You have to set the path of IconPicker JSON file to "jsonUrl" option. e.g. '/content/plugins/IconPicker/dist/iconpicker-1.5.0.json'
                jsonUrl: '/assets/iconpicker-1.5.0.json',
                // Optional: Change the buttons or search placeholder text according to the language.
                searchPlaceholder: 'Search Icon',
                showAllButton: 'Show All',
                cancelButton: 'Cancel',
                noResultsFound: 'No results found.', // v1.5.0 and the next versions
                borderRadius: '20px', // v1.5.0 and the next versions
            });

            IconPicker.Run('#GetIconPicker', function () {
                // ng-bind no funciona para asignar el icono porque no detecta el cambio que hacemos con el IconPicker, así que hay que hacerlo a pelo.
                let icon = document.querySelector("#IconPreview").getAttribute("class");
                icon = icon.substring(icon.indexOf('-') + 1);
                $scope.event_type.icon = icon;

            });

                                       
        $scope.saveEventUserProfile = function () {            
            if (angular.isDefined($scope.event_type.id)) {
                $scope.event_type.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('events_types.edit_success'));                        
                        $state.go("events_types.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('EventsTypes').post($scope.event_type).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('events_types.save_success'));
                        $state.go("events_types.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('events_types.button_delete'),
                message: $filter('translate')('events_types.delete_message') + " " + $scope.event_type.name + "?",
                onAccept: function () {
                    $scope.event_type.remove().then(function () {
                        toastr.success($filter('translate')('events_types.deleted_success'));
                        $state.go("events_types.list");
                    });
                }
            });
        };        

}])

;

